(() => {
  const variantName = 'refined-b-20260805';
  const goalSelector = '[data-pn-cart-goal]';

  if (window.pawsnovaCartDrawerB || !document.body || !document.body.dataset || document.body.dataset.pnCroVariant !== variantName) return;
  window.pawsnovaCartDrawerB = true;

  const fetchCart = async () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const response = await fetch(`${root}paws-v14-cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  };

  const getCurrencyCode = (goal) => (goal && goal.dataset && goal.dataset.currencyCode) ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const getLocale = (goal) => (goal && goal.dataset && goal.dataset.locale) || document.documentElement.lang || 'en-US';

  const formatMoney = (cents, goal) => {
    const amount = Math.max(0, Number(cents) || 0) / 100;
    const hasCents = Math.round(Math.max(0, Number(cents) || 0)) % 100 !== 0;
    return new Intl.NumberFormat(getLocale(goal), {
      style: 'currency',
      currency: getCurrencyCode(goal),
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    }).format(amount);
  };

  const getEligibleSingleBoxQuantity = (cart) => {
    return (cart.items || []).reduce((total, item) => {
      const properties = item.properties || {};
      const isEligibleSingleBox = properties._pn_eligible_single_box === 'true';
      return isEligibleSingleBox ? total + Number(item.quantity || 0) : total;
    }, 0);
  };

  const setGoalProgress = (goal, progress) => {
    goal.style.setProperty('--pn-cart-goal-progress', `${Math.max(0, Math.min(100, progress))}%`);
  };

  const setShippingDetailsVisibility = (goal, visible) => {
    const shippingDetails = goal.querySelector('[data-pn-cart-goal-shipping-details]');
    if (!shippingDetails) return;
    shippingDetails.hidden = !visible;
    if (!visible) shippingDetails.open = false;
  };

  const renderGoal = (cart) => {
    const goal = document.querySelector(goalSelector);
    if (!goal) return;

    const eyebrow = goal.querySelector('[data-pn-cart-goal-eyebrow]');
    const title = goal.querySelector('[data-pn-cart-goal-title]');
    const text = goal.querySelector('[data-pn-cart-goal-text]');
    const threshold = Number(goal.dataset.freeShippingThreshold || 5900);
    const itemCount = Number(cart.item_count || 0);
    const bogoEnabled = goal.dataset.bogoEnabled === 'true';

    if (!itemCount) {
      setShippingDetailsVisibility(goal, false);
      goal.hidden = true;
      return;
    }

    const eligibleCount = bogoEnabled ? getEligibleSingleBoxQuantity(cart) : 0;
    const totalPrice = Number(cart.total_price || 0);
    goal.hidden = false;

    if (bogoEnabled && eligibleCount > 0 && eligibleCount < 3) {
      setShippingDetailsVisibility(goal, false);
      const remaining = 3 - eligibleCount;
      eyebrow.textContent = 'Buy 3, Pay for 2';
      title.textContent = `Add ${remaining} More Eligible Single ${remaining === 1 ? 'Box' : 'Boxes'}`;
      text.textContent = `${eligibleCount}/3 eligible single boxes in cart. Choose the Single Box option to unlock the offer at checkout.`;
      setGoalProgress(goal, (eligibleCount / 3) * 100);
      return;
    }

    setShippingDetailsVisibility(goal, true);

    if (totalPrice < threshold) {
      eyebrow.textContent = 'Free shipping progress';
      title.textContent = `${formatMoney(threshold - totalPrice, goal)} Away from Free Shipping`;
      text.textContent = bogoEnabled && eligibleCount >= 3
        ? `Buy 3, Pay for 2 is ready. Add more items to unlock free shipping at ${formatMoney(threshold, goal)}.`
        : `Free standard shipping starts at ${formatMoney(threshold, goal)}. Exclusions apply; see shipping details.`;
      setGoalProgress(goal, (totalPrice / threshold) * 100);
      return;
    }

    eyebrow.textContent = 'Free shipping unlocked';
    title.textContent = 'Free Shipping Unlocked';
    text.textContent = bogoEnabled && eligibleCount >= 3
      ? 'Buy 3, Pay for 2 is ready and your cart reached the free shipping threshold. Exclusions still apply.'
      : 'Your cart reached the free shipping threshold. Delivery-area and item exclusions still apply.';
    setGoalProgress(goal, 100);
  };

  let refreshPromise = null;
  const refreshGoal = () => {
    if (refreshPromise) return refreshPromise;
    refreshPromise = fetchCart()
      .then(renderGoal)
      .catch(() => {
        const goal = document.querySelector(goalSelector);
        if (goal) goal.hidden = true;
      })
      .finally(() => { refreshPromise = null; });
    return refreshPromise;
  };

  const requestRefresh = () => window.requestAnimationFrame(refreshGoal);
  document.addEventListener('DOMContentLoaded', refreshGoal);
  document.addEventListener('cart:updated', requestRefresh);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, requestRefresh);
  }

  const observer = new MutationObserver((mutations) => {
    const shouldRefresh = mutations.some((mutation) => Array.from(mutation.addedNodes || []).some((node) =>
      node.nodeType === 1 && ((node.matches && node.matches(goalSelector)) || (node.querySelector && node.querySelector(goalSelector)))
    ));
    if (shouldRefresh) requestRefresh();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
